import { render, staticRenderFns } from "./Video-player.vue?vue&type=template&id=12761e27&scoped=true"
import script from "./Video-player.vue?vue&type=script&lang=js"
export * from "./Video-player.vue?vue&type=script&lang=js"
import style0 from "./Video-player.vue?vue&type=style&index=0&id=12761e27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12761e27",
  null
  
)

export default component.exports